import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';


@Component({
    selector: 'app-button',
    imports: [NgClass],
    templateUrl: './button.component.html',
    styleUrl: './button.component.scss'
})
export class ButtonComponent {
    @Input()
    disabled: any;

    @Input()
    type: string = "default";

    @Input()
    title: string = "";

    get _disabled(): boolean {
        return !!this._disabled;
    }
}
